import React, { useEffect } from 'react'
import { useState } from 'react';
import BlockUi from '@availity/block-ui';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Form, InputPicker, SelectPicker } from 'rsuite';
import LegacySpinnerIcon from "@rsuite/icons/legacy/Spinner";
import paymentService from '../../../../services/Internal/Revenue/payment.service';
import { getContacts, getPaymentTypes } from '../../../../services/Shared/codeTable.service';
import CurrencyMask from '../../../Shared/GenericComponents/CurrencyMask';
import PaymentSearchGrid from './PaymentSearchGrid'

function PaymentSearchPage() {
    const [isSearching, setIsSearching] = useState(false);
    const [contactLoading, setContactLoading] = useState(false);
    const [paymentType, setPaymentType] = useState([]);
    const [contacts, setContacts] = useState();
    const [gridData, setGridData] = useState([]);
    const [searchModel, setSearchModel] = useState({
        paymentId: '',
        paymentType: null,
        paymentStartDate: '',
        paymentEndDate: '',
        checkNumber: '',
        contact: null,
        amountMin: '',
        amountMax: '',
    })

    useEffect(() => {
        getPaymentTypes().then(setPaymentType);
    }, [])

    const updateContacts = (value) => {
        if (value.length > 2) {
            getContacts(value).then((response) => {
                setContactLoading(true);
                setContacts(response);
                setContactLoading(false);
            });
        }
        else {
            setContacts([]);
        }
    }

    const clearSearchModel = () => {
        setSearchModel({
            paymentId: '',
            paymentType: null,
            paymentStartDate: '',
            paymentEndDate: '',
            checkNumber: '',
            contact: '',
            amountMin: '',
            amountMax: ''
        })
    }
    const submitSearch = () => {
        setIsSearching(true)
        var dataToTransmit = {
            paymentId: searchModel.paymentId == '' ? null : searchModel.paymentId,
            paymentType: searchModel.paymentType?.paymentType ?? null,
            dateCrteBegin: searchModel.paymentStartDate ? new Date(searchModel.paymentStartDate) : null,
            dateCrteEnd: searchModel.paymentEndDate ? new Date(searchModel.paymentEndDate) : null,
            authorizationNumber: searchModel.checkNumber ? searchModel.checkNumber : null,
            contactEntityId: searchModel.contact?.entityId ?? null,
            amountMin: searchModel.amountMin == '' ? null : searchModel.amountMin,
            amountMax: searchModel.amountMax == '' ? null : searchModel.amountMax
        }
        paymentService.searchPayments(dataToTransmit).then((response) => {
            if (response.data) {
                setGridData(response.data);
            }

        }).then(() => {
            setIsSearching(false);
        })
    }

    return <>
        <Card className="mb-3">
            <Card.Header>
                <h5>
                    Payment Search
                </h5>
            </Card.Header>
            <Card.Body>
                <BlockUi blocking={isSearching}>
                    <Form fluid formValue={searchModel} onChange={setSearchModel} onSubmit={submitSearch} >
                        <Row className="mb-3 d-flex justify-content-between">
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel><b>Payment ID</b></Form.ControlLabel>
                                    <Form.Control name="paymentId" placeholder="Payment ID" type="number" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel><b>Payment Type</b></Form.ControlLabel>
                                    <Form.Control
                                        name="paymentType"
                                        placeholder="Select Type"
                                        block
                                        data={paymentType}
                                        accepter={SelectPicker}
                                        searchable={false} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel><b>Payment Date Created</b></Form.ControlLabel>
                                    <Form.Control name="paymentStartDate" type="date" block />
                                </Form.Group>
                            </Col>
                            <Col xs="auto" style={{ marginTop: '1.5em' }} className="d-flex align-items-center">to</Col>
                            <Col>
                                <Form.ControlLabel>&nbsp;</Form.ControlLabel>
                                <Form.Control name="paymentEndDate" type="date" block />
                            </Col>
                            <Col>
                                <Form.ControlLabel><b>Check#/CC Auth Number</b></Form.ControlLabel>
                                <Form.Control name="checkNumber" placeholder="Enter Authorization Number" />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={7}>
                                <Form.Group>
                                    <Form.ControlLabel><b>Contact</b></Form.ControlLabel>
                                    <Form.Control
                                        accepter={InputPicker}
                                        block
                                        data={contacts}
                                        name="contact"
                                        labelKey="name"
                                        placeholder="Find a Contact (Min 3 characters)"
                                        onSearch={updateContacts}
                                        renderMenu={menu => {
                                            if (contactLoading) {
                                                return (
                                                    <p style={{ padding: 4, color: '#999', textAlign: 'center' }}>
                                                        <LegacySpinnerIcon spin /> Loading...
                                                    </p>
                                                );
                                            }
                                            return menu;
                                        }}
                                        renderMenuItem={(label, item) => {
                                            return (
                                                <>
                                                    {`${item.value.formattedName} ${item.value.formattedLicenseNumber ? "| " + item.value.formattedLicenseNumber : ""} | ${item.value.lolanumber}`}
                                                </>
                                            );
                                        }}
                                        renderValue={(value, item, selectedElement) => {
                                            return (
                                                <>
                                                    {item ? `${item.value.formattedName} ${item.value.formattedLicenseNumber ? "| " + item.value.formattedLicenseNumber : ""} | ${item.value.lolanumber} ` : 'Find a Contact (Min 3 characters)'}
                                                </>
                                            );
                                        }} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel><b>Amount Range</b></Form.ControlLabel>
                                    <Form.Control
                                        accepter={CurrencyMask}
                                        name="amountMin"
                                        block
                                        placeholder="Minimum Amount" />
                                </Form.Group>
                            </Col>
                            <Col xs="auto" style={{ marginTop: '1.5em' }} className="d-flex align-items-center">to</Col>
                            <Col>
                                <Form.ControlLabel>&nbsp;</Form.ControlLabel>
                                <Form.Control
                                    accepter={CurrencyMask}
                                    name="amountMax"
                                    block
                                    placeholder="Maximum Amount" />
                            </Col>
                        </Row>
                        <hr />
                        <div style={{ textAlign: 'right' }}>
                            <Button onClick={clearSearchModel} variant="danger" className="me-2">Reset</Button>
                            <Button type="submit">Search</Button>
                        </div>
                    </Form>
                </BlockUi>
            </Card.Body>
        </Card>
        <PaymentSearchGrid gridData={gridData} setIsSearchingCallback={setIsSearching} />
    </>;
}

export default PaymentSearchPage;